import { useState } from 'react';
import { Button } from '../design/Button';
import { Panel } from '../design/Panel';
import { Label } from '../design/Paper';
import { ro } from '../i18n/ro';

/**
 * One of the room's links, labelled and described for what it is.
 *
 * Two exist — one for players, one for the shared screen — and they are easy to
 * confuse with each other, so each says plainly who it is for. A single
 * unlabelled link under a bare "copy" button is how the wrong URL gets handed
 * round.
 */
export function LinkRow({
  title,
  body,
  url,
  testId,
}: {
  title: string;
  body: string;
  url: string;
  testId?: string;
}) {
  const [copied, setCopied] = useState(false);

  return (
    <div>
      <div className="flex items-baseline justify-between gap-3">
        <Label className="text-[0.65rem] text-ink-soft">{title}</Label>
        <Button
          size="sm"
          tone="ghost"
          onClick={() => {
            void navigator.clipboard
              ?.writeText(url)
              .then(() => setCopied(true))
              .catch(() => undefined);
          }}
        >
          {copied ? ro.copied : ro.copy}
        </Button>
      </div>
      <p className="mt-1 text-xs text-ink-soft">{body}</p>
      <Panel tone="raised" press="sm" className="mt-2" innerClassName="p-2.5">
        <code data-testid={testId} className="block break-all text-[0.7rem] leading-relaxed">
          {url}
        </code>
      </Panel>
    </div>
  );
}
